import { Component } from '@angular/core';
import { map } from 'rxjs';

import { TriggerAction } from '@shared/actions';
import { StateManagerProjectService } from '@state-manager';
import { CornerstoneService } from '@viewer/cornerstone.service';
import { CornerstoneTool } from '@viewer/data';
import { BaseToolComponent } from '../base-tool/base-tool.component';

@Component({
  selector: 'app-brightness-tool',
  templateUrl: 'brightness-tool.component.html',
  styleUrls: ['brightness-tool.component.scss'],
})
export class BrightnessToolComponent extends BaseToolComponent {
  public brightnessAction: TriggerAction;

  constructor(
    public stateProjectManagerService: StateManagerProjectService,
    private _cornerstoneService: CornerstoneService
  ) {
    super(stateProjectManagerService);
    this.brightnessAction = new TriggerAction(
      'brightness',
      'Bright./Contrast',
      this._onActivateToolBtnClick.bind(this)
    );

    this.brightnessAction.isEnable = () =>
      this.isDisabled$.pipe(map((x) => !x));
  }

  private _onActivateToolBtnClick(): void {
    this._activateTool();
  }

  private _activateTool(): void {
    if (this.stateProjectManagerService.currentTool === CornerstoneTool.Wwwc) {
      this._cornerstoneService.toolActivate(CornerstoneTool.EmptyTool);
    } else {
      this._cornerstoneService.toolActivate(CornerstoneTool.Wwwc);
    }
  }
}
